import { render } from "./GuestList.vue?vue&type=template&id=122104de"
import script from "./GuestList.vue?vue&type=script&lang=js"
export * from "./GuestList.vue?vue&type=script&lang=js"

import "./GuestList.vue?vue&type=style&index=0&id=122104de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__